<template>
  <div class="mt-16 max-w-2xl">
    <div class="font-semibold text-2xl">
      Provide your card details:
    </div>

    <input
      v-if="!isLoggedIn"
      class="shadow w-full p-2 rounded mt-8 text-sm"
      type="text"
      placeholder="Email"
      v-model="email"
    />
    <input
      class="shadow w-full p-2 rounded mt-4 text-sm"
      type="text"
      placeholder="Name on Credit Card"
      v-model="card_owner"
    />

    <stripe-element-card
      ref="checkout"
      :pk="publishableKey"
      :hidePostalCode="true"
      @token="tokenCreated"
      @loading="progressSaving = $event"
    />
    <div class="mt-8">
      <StyledButton
        :disabled="!canSubmit"
        @click="$refs.checkout.submit()"
        type="primary"
        class="mr-2"
      >
        Add Card
      </StyledButton>
      <StyledButton @click="$emit('canceled')" type="secondary">
        Cancel
      </StyledButton>
    </div>
  </div>
</template>

<script>
import { StripeElementCard } from '@vue-stripe/vue-stripe'
import StyledButton from '@/components/common/controls/StyledButton'
import ApiV1 from '@/api/api_v1.0'

export default {
  name: 'StripeCardComponent',
  components: {
    StripeElementCard,
    StyledButton,
  },

  data() {
    return {
      publishableKey: process.env.VUE_APP_STRIPE_API_KEY,
      progressSaving: false,
      card_owner: '',
      email: null,
    }
  },

  mounted() {
    const cardTimerIndex = setInterval(() => {
      if (this.$refs.checkout?.card) {
        this.$refs.checkout.card.update({ hidePostalCode: true })

        clearInterval(cardTimerIndex)
      }
    }, 1000)
  },

  computed: {
    canSubmit() {
      return (
        this.card_owner.length > 0 &&
        ((!this.isLoggedIn && this.email.length > 0) || this.isLoggedIn)
      )
    },
  },

  methods: {
    async tokenCreated(token) {
      this.progressSaving = true

      const expires_date =
        (token.card.exp_month < 10
          ? '0' + token.card.exp_month
          : token.card.exp_month) +
        '/' +
        (token.card.exp_year - 2000)
      const card_type = token.card.brand

      // if not logged in - find or create user - login - add payment source
      if (!this.isLoggedIn) {
        const response = await ApiV1.partialRegistration({
          email: this.email,
        })

        // store login date
        await this.$store.commit('SET_AUTH_DATA', {
          user: response.data.data,
          token: response.data.token,
        })
      }

      ApiV1.addPaymentSource({
        token: token.id,
        last4: token.card.last4,
        owner_name: this.card_owner,
        card_type: card_type,
        expires_date: expires_date,
      })
        .then(response => {
          this.progressSaving = false

          this.$store.dispatch(
            'setSuccessMessage',
            'Your payment card successfully stored!',
          )

          this.$emit('success')
        })
        .catch(() => {
          this.progressSaving = false
        })
    },
  },
}
</script>
